export default "__VITE_ASSET__CHbGWi6S__"